import { useCallback } from 'react';
import { type MultiActionQuery } from '#shared/api/schema';
import { showError, showSuccess } from '#shared/lib/toast';
import { deletePermanentlyProductVariants } from '../api';

export type UseProductVariantsPermanentDeleteParams = {
    query: MultiActionQuery;
    confirmDelete: () => Promise<boolean>;
    onDelete?: VoidFunction;
    count?: number;
};

export const useProductVariantsPermanentDelete = ({
    query,
    confirmDelete,
    onDelete,
    count = query.variant_ids?.length,
}: UseProductVariantsPermanentDeleteParams) => {
    const permanentDelete = useCallback(async () => {
        try {
            const isConfirmed = await confirmDelete();

            if (!isConfirmed) {
                return;
            }

            await deletePermanentlyProductVariants({ body: { query } });
            showSuccess(count && count > 1 ? 'Товары удалены' : 'Товар удален');
            onDelete?.();
        } catch (error) {
            showError(
                {
                    label: 'Произошла ошибка при удалении. Повторите попытку через некоторое время',
                },
                error
            );
        }
    }, [confirmDelete, query, count, onDelete]);

    return { permanentDelete };
};
